import React from "react";
import { Link } from "react-router-dom";
import Logo from "../brand/Logo";

export const Footer = () => {
    const year = new Date().getFullYear();
    return (
        <footer
            data-testid="site-footer"
            className="bg-[#050B14] text-white border-t border-white/10"
        >
            <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-16 lg:py-20">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-8">
                    <div className="lg:col-span-5">
                        <Logo variant="dark" />
                        <p className="mt-6 text-white/60 max-w-md leading-relaxed">
                            ELWIS — Electric Wireless Solutions. Intelligent wireless
                            charging for commercial vehicles, industrial equipment and
                            smart infrastructure.
                        </p>
                        <div className="mt-8 flex flex-wrap gap-3">
                            <Link
                                to="/contact"
                                data-testid="footer-cta-discuss"
                                className="inline-flex items-center gap-1.5 bg-[#00E5FF] text-[#050B14] px-4 py-2.5 rounded-md text-sm font-semibold hover:bg-white transition-colors"
                            >
                                Discuss Your Project
                            </Link>
                            <Link
                                to="/technology"
                                data-testid="footer-cta-tech"
                                className="inline-flex items-center gap-1.5 border border-white/20 text-white px-4 py-2.5 rounded-md text-sm font-semibold hover:border-[#00E5FF] hover:text-[#00E5FF] transition-colors"
                            >
                                Technology Overview
                            </Link>
                        </div>
                    </div>

                    <div className="lg:col-span-2">
                        <h4 className="kicker text-white/40 mb-4">Company</h4>
                        <ul className="space-y-3 text-sm">
                            <li>
                                <Link to="/about" className="text-white/80 hover:text-[#00E5FF]" data-testid="footer-about-link">About</Link>
                            </li>
                            <li>
                                <Link to="/industries" className="text-white/80 hover:text-[#00E5FF]" data-testid="footer-industries-link">Industries</Link>
                            </li>
                            <li>
                                <Link to="/contact" className="text-white/80 hover:text-[#00E5FF]" data-testid="footer-contact-link">Contact</Link>
                            </li>
                        </ul>
                    </div>

                    <div className="lg:col-span-2">
                        <h4 className="kicker text-white/40 mb-4">Platform</h4>
                        <ul className="space-y-3 text-sm">
                            <li>
                                <Link to="/technology" className="text-white/80 hover:text-[#00E5FF]" data-testid="footer-tech-link">Technology</Link>
                            </li>
                            <li>
                                <Link to="/industries" className="text-white/80 hover:text-[#00E5FF]">Use Cases</Link>
                            </li>
                            <li>
                                <Link to="/contact" className="text-white/80 hover:text-[#00E5FF]">Partnerships</Link>
                            </li>
                        </ul>
                    </div>

                    <div className="lg:col-span-3">
                        <h4 className="kicker text-white/40 mb-4">Headquarters</h4>
                        <p className="text-sm text-white/70 leading-relaxed">
                            ELWIS Engineering<br />
                            Future Infrastructure Park<br />
                            Innovation District<br />
                            <a
                                href="mailto:partnerships@elwis.io"
                                className="text-[#00E5FF] hover:underline mt-2 inline-block"
                                data-testid="footer-email-link"
                            >
                                partnerships@elwis.io
                            </a>
                        </p>
                    </div>
                </div>

                <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row md:items-center md:justify-between gap-4">
                    <p className="text-xs text-white/40 font-mono tracking-wider uppercase">
                        © {year} ELWIS — Electric Wireless Solutions. All rights reserved.
                    </p>
                    <p className="text-xs text-white/40 font-mono tracking-wider uppercase">
                        Building wireless infrastructure for real-world commercial operations.
                    </p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
